let t = s => s; //text have to be placed in t() to be recognizable by translation extractor
let replacements = {
    "Soccerset0": t("1st Half"),
    "Soccerset1": t("1st Half"),
    "Soccerset2": t("2nd Half"),
    "Soccerset3": t("Extra Time 1st Half"),
    "Soccerset4": t("Extra Time 2nd Half"),
    "Soccerset5": t("penalties"),
    "CyberFootballset0": t("1st Half"),
    "CyberFootballset1": t("1st Half"),
    "CyberFootballset2": t("2nd Half"),
    "CyberFootballset3": t("Extra Time 1st Half"),
    "CyberFootballset4": t("Extra Time 2nd Half"),
    "CyberFootballset5": t("penalties"),
    "Socceradditional_time1": t("Additional Time1"),
    "Socceradditional_time2": t("Additional Time2"),
    "Soccerpenalty": t("Penalty"),
    "Soccerfinished": t("Finished"),
    "finished": t("Finished"),
    "notstarted": t("Not started yet"),
    "Soccerwait": t("Waiting"),
    "Soccertimeout": t("Timeout"),
    "Boxingset": t("Round"),
    "Boxingset0": t("Round 0"),
    "Boxingset1": t("Round 1"),
    "Boxingset2": t("Round 2"),
    "Boxingset3": t("Round 3"),
    "Boxingset4": t("Round 4"),
    "Boxingset5": t("Round 5"),
    "Boxingset6": t("Round 6"),
    "Boxingset7": t("Round 7"),
    "Boxingset8": t("Round 8"),
    "Boxingset9": t("Round 9"),
    "Boxingset10": t("Round 10"),
    "Boxingset11": t("Round 11"),
    "Boxingset12": t("Round 12"),
    "Tennisset": t("Set"),
    "Tennisset0": t("Set 0"),
    "Tennisset1": t("Set 1"),
    "Tennisset2": t("Set 2"),
    "Tennisset3": t("Set 3"),
    "Tennisset4": t("Set 4"),
    "Tennisset5": t("Set 5"),
    "Tennisset6": t("Set 6"),
    "Tennisset7": t("Set 7"),
    "Tennisset8": t("Set 8"),
    "Tennisset9": t("Set 9"),
    "Tennisset10": t("Set 10"),
    "IceHockeyset": t("Period"),
    "IceHockeyset0": t("Period 0"),
    "IceHockeyset1": t("Period 1"),
    "IceHockeyset2": t("Period 2"),
    "IceHockeyset3": t("Period 3"),
    "IceHockeyset4": t("Period 4"),
    "EBasketballset": t("Quarter"),
    "EBasketballset0": t("Quarter 0"),
    "EBasketballset1": t("Quarter 1"),
    "EBasketballset2": t("Quarter 2"),
    "EBasketballset3": t("Quarter 3"),
    "EBasketballset4": t("Quarter 4"),
    "EBasketballset5": t("OT"),
    "Basketballset": t("Quarter"),
    "Basketballset0": t("Quarter 0"),
    "Basketballset1": t("Quarter 1"),
    "Basketballset2": t("Quarter 2"),
    "Basketballset3": t("Quarter 3"),
    "Basketballset4": t("Quarter 4"),
    "Basketballset5": t("OT"),
    "Volleyballset": t("Set"),
    "Volleyballset0": t("Set 0"),
    "Volleyballset1": t("Set 1"),
    "Volleyballset2": t("Set 2"),
    "Volleyballset3": t("Set 3"),
    "Volleyballset4": t("Set 4"),
    "Volleyballset5": t("Set 5"),
    "Volleyballset6": t("Set 6"),
    "Volleyballset7": t("Set 7"),
    "Volleyballset8": t("Set 8"),
    "Volleyballset9": t("Set 9"),
    "Volleyballset10": t("Set 10"),
    "Handballset": t("Half"),
    "Handballset0": t("0 Half"),
    "Handballset1": t("1st Half"),
    "Handballset2": t("2nd Half"),
    "Baseballset": t("Inning"),
    "Baseballset0": t("Inning 0"),
    "Baseballset1": t("1st Inning"),
    "Baseballset2": t("2nd Inning"),
    "Baseballset3": t("3rd Inning"),
    "Baseballset4": t("4th Inning"),
    "Baseballset5": t("5th Inning"),
    "Baseballset6": t("6th Inning"),
    "Baseballset7": t("7th Inning"),
    "Baseballset8": t("8th Inning"),
    "Baseballset9": t("9th Inning"),
    "Baseballset10": t("10th Inning"),
    "Baseballset11": t("11th Inning"),
    "Baseballset12": t("12th Inning"),
    "Baseballset13": t("13th Inning"),
    "Baseballset14": t("14th Inning"),
    "Baseballset15": t("15th Inning"),
    "Baseballset16": t("16th Inning"),
    "Baseballset17": t("17th Inning"),
    "Baseballset18": t("18th Inning"),
    "Baseballset19": t("19th Inning"),
    "Baseballset20": t("20th Inning"),
    "Baseballset21": t("21th Inning"),
    "Baseballset22": t("22th Inning"),
    "Baseballset23": t("23th Inning"),
    "Baseballset24": t("24th Inning"),
    "Baseballset25": t("25th Inning"),
    "BeachVolleyballset": t("Set"),
    "BeachVolleyballset1": t("Set 1"),
    "BeachVolleyballset2": t("Set 2"),
    "BeachVolleyballset3": t("Set 3"),
    "BeachSoccerset": t("Period"),
    "BeachSoccerset1": t("Period 1"),
    "BeachSoccerset2": t("Period 2"),
    "BeachSoccerset3": t("Period 3"),
    "Rugbyset": t("Time"),
    "Rugbyset0": t("Time 0"),
    "Rugbyset1": t("1st Half"), //"Time 1"),
    "Rugbyset2": t("2nd Half"), //"Time 2"),
    "Snookerset": t("Frame"),
    "Snookerset0": t("Frame 0"),
    "Snookerset1": t("Frame 1"),
    "Snookerset2": t("Frame 2"),
    "Snookerset3": t("Frame 3"),
    "Snookerset4": t("Frame 4"),
    "Snookerset5": t("Frame 5"),
    "Snookerset6": t("Frame 6"),
    "Snookerset7": t("Frame 7"),
    "Snookerset8": t("Frame 8"),
    "Snookerset9": t("Frame 9"),
    "Snookerset10": t("Frame 10"),
    "Snookerset11": t("Frame 11"),
    "Snookerset12": t("Frame 12"),
    "Snookerset13": t("Frame 13"),
    "Snookerset14": t("Frame 14"),
    "Snookerset15": t("Frame 15"),
    "Snookerset16": t("Frame 16"),
    "Snookerset17": t("Frame 17"),
    "Snookerset18": t("Frame 18"),
    "Snookerset19": t("Frame 19"),
    "Snookerset20": t("Frame 20"),
    "Snookerset21": t("Frame 21"),
    "Snookerset22": t("Frame 22"),
    "Snookerset23": t("Frame 23"),
    "Snookerset24": t("Frame 24"),
    "Snookerset25": t("Frame 25"),
    "Snookerset26": t("Frame 26"),
    "Snookerset27": t("Frame 27"),
    "Snookerset28": t("Frame 28"),
    "Snookerset29": t("Frame 29"),
    "Snookerset30": t("Frame 30"),
    "Snookerset31": t("Frame 31"),
    "Snookerset32": t("Frame 32"),
    "Snookerset33": t("Frame 33"),
    "Snookerset34": t("Frame 34"),
    "Snookerset35": t("Frame 35"),
    "Snookerset36": t("Frame 36"),
    "Snookerset37": t("Frame 37"),
    "Snookerset38": t("Frame 38"),
    "Snookerset39": t("Frame 39"),
    "AmericanFootballset": t("Quarter"),
    "AmericanFootballset0": t("Quarter 0"),
    "AmericanFootballset1": t("Quarter 1"),
    "AmericanFootballset2": t("Quarter 2"),
    "AmericanFootballset3": t("Quarter 3"),
    "AmericanFootballset4": t("Quarter 4"),
    "AustralianFootballset": t("Quarter"),
    "AustralianFootballset0": t("Quarter 0"),
    "AustralianFootballset1": t("Quarter 1"),
    "AustralianFootballset2": t("Quarter 2"),
    "AustralianFootballset3": t("Quarter 3"),
    "AustralianFootballset4": t("Quarter 4"),
    "WaterPoloset": t("Period"),
    "WaterPoloset0": t("Period 0"),
    "WaterPoloset1": t("Period 1"),
    "WaterPoloset2": t("Period 2"),
    "WaterPoloset3": t("Period 3"),
    "WaterPoloset4": t("Period 4"),
    "WaterPoloset5": t("Period 5"),
    "WaterPoloset6": t("Period 6"),
    "MiniSoccerset": t("Time"),
    "MiniSoccerset0": t("Time 0"),
    "MiniSoccerset1": t("1st Half"), //"Time 1"
    "MiniSoccerset2": t("2nd Half"), //"Time 2"),
    "BallHockeyset": t("Period"),
    "BallHockeyset1": t("Period 1"),
    "BallHockeyset2": t("Period 2"),
    "TableTennisset": t("Set"),
    "TableTennisset1": t("Set 1"),
    "TableTennisset2": t("Set 2"),
    "TableTennisset3": t("Set 3"),
    "TableTennisset4": t("Set 4"),
    "TableTennisset5": t("Set 5"),
    "TableTennisset6": t("Set 6"),
    "TableTennisset7": t("Set 7"),
    "Badmintonset": t("Game"),
    "Badmintonset1": t("Game 1"),
    "Badmintonset2": t("Game 2"),
    "Badmintonset3": t("Game 3"),
    "Squashset": t("Game"),
    "Squashset0": t(" 0"),
    "Squashset1": t("Game 1"),
    "Squashset2": t("Game 2"),
    "Squashset3": t("Game 3"),
    "Squashset4": t("Game 4"),
    "Squashset5": t("Game 5"),
    "Netballset": t("Quarter"),
    "Netballset1": t("Quarter 1"),
    "Netballset2": t("Quarter 2"),
    "Netballset3": t("Quarter 3"),
    "Netballset4": t("Quarter 4"),
    "Dotaset1": t("Game-1"),
    "Dotaset2": t("Game-2"),
    "Dotaset3": t("Game-3"),
    "Dotaset4": t("Game-4"),
    "Dotaset5": t("Game-5"),
    "Dotaset6": t("Game-6"),
    "Dotaset7": t("Game-7"),
    "Dota2set1": t("Game-1"),
    "Dota2set2": t("Game-2"),
    "Dota2set3": t("Game-3"),
    "Dota2set4": t("Game-4"),
    "Dota2set5": t("Game-5"),
    "Dota2set6": t("Game-6"),
    "Dota2set7": t("Game-7"),
    "CounterStrikeset": t("Map"),
    "CounterStrikeset1": t("Map 1"),
    "CounterStrikeset2": t("Map 2"),
    "CounterStrikeset3": t("Map 3"),
    "CounterStrikeset4": t("Map 4"),
    "CounterStrikeset5": t("Map 5"),
    "CounterStrikeset6": t("Map 6"),
    "CounterStrikeset7": t("Map 7"),
    "Hearthstoneset": t("Game"),
    "Hearthstoneset1": t("Game-1"),
    "Hearthstoneset2": t("Game-2"),
    "Hearthstoneset3": t("Game-3"),
    "Hearthstoneset4": t("Game-4"),
    "Hearthstoneset5": t("Game-5"),
    "Hearthstoneset6": t("Game-6"),
    "Hearthstoneset7": t("Game-7"),
    "HeroesOfTheStorm": t("Game"),
    "HeroesOfTheStorm1": t("Game-1"),
    "HeroesOfTheStorm2": t("Game-2"),
    "HeroesOfTheStorm3": t("Game-3"),
    "HeroesOfTheStorm4": t("Game-4"),
    "HeroesOfTheStorm5": t("Game-5"),
    "HeroesOfTheStorm6": t("Game-6"),
    "HeroesOfTheStorm7": t("Game-7"),
    "LeagueOfLegendsset": t("Game"),
    "LeagueOfLegendsset1": t("Game-1"),
    "LeagueOfLegendsset2": t("Game-2"),
    "LeagueOfLegendsset3": t("Game-3"),
    "LeagueOfLegendsset4": t("Game-4"),
    "LeagueOfLegendsset5": t("Game-5"),
    "LeagueOfLegendsset6": t("Game-6"),
    "LeagueOfLegendsset7": t("Game-7"),
    "LeagueofLegendsset": t("Game"),
    "LeagueofLegendsset1": t("Game-1"),
    "LeagueofLegendsset2": t("Game-2"),
    "LeagueofLegendsset3": t("Game-3"),
    "LeagueofLegendsset4": t("Game-4"),
    "LeagueofLegendsset5": t("Game-5"),
    "LeagueofLegendsset6": t("Game-6"),
    "LeagueofLegendsset7": t("Game-7"),
    "StarCraftset": t("Map"),
    "StarCraftset1": t("Map 1"),
    "StarCraftset2": t("Map 2"),
    "StarCraftset3": t("Map 3"),
    "StarCraftset4": t("Map 4"),
    "StarCraftset5": t("Map 5"),
    "StarCraftset6": t("Map 6"),
    "StarCraftset7": t("Map 7"),
    "StarCraft2set": t("Map"),
    "StarCraft2set1": t("Map 1"),
    "StarCraft2set2": t("Map 2"),
    "StarCraft2set3": t("Map 3"),
    "StarCraft2set4": t("Map 4"),
    "StarCraft2set5": t("Map 5"),
    "StarCraft2set6": t("Map 6"),
    "StarCraft2set7": t("Map 7"),
    "set": t("Set"),
    "set0": t("Set 0"),
    "set1": t("Set 1"),
    "set2": t("Set 2"),
    "set3": t("Set 3"),
    "set4": t("Set 4"),
    "set5": t("Set 5"),
    "set6": t("Set 6"),
    "set7": t("Set 7"),
    "set8": t("Set 8"),
    "set9": t("Set 9"),
    "set10": t("Set 10"),
    "set11": t("Set 11"),
    "set12": t("Set 12"),
    "set13": t("Set 13"),
    "set14": t("Set 14"),
    "set15": t("Set 15"),
    "set16": t("Set 16"),
    "set17": t("Set 17"),
    "set18": t("Set 18"),
    "set19": t("Set 19"),
    "set20": t("Set 20"),
    "Cricketset": t("Inning"),
    "Cricketset0": t("Inning 0"),
    "Cricketset1": t("1st Inning"),
    "Cricketset2": t("2nd Inning"),
    "Cricketset3": t("3rd Inning"),
    "Cricketset4": t("4th Inning"),
    "Cricketset5": t("5th Inning"),
    "Cricketset6": t("6th Inning"),
    "Cricketset7": t("7th Inning"),
    "Cricketset8": t("8th Inning"),
    "Cricketset9": t("9th Inning"),
    "Cricketset10": t("10th Inning"),
    "Cricketset11": t("11th Inning"),
    "Cricketset12": t("12th Inning"),
    "Cricketset13": t("13th Inning"),
    "Cricketset14": t("14th Inning"),
    "Cricketset15": t("15th Inning"),
    "Cricketset16": t("16th Inning"),
    "Cricketset17": t("17th Inning"),
    "Cricketset18": t("18th Inning"),
    "Cricketset19": t("19th Inning"),
    "Cricketset20": t("20th Inning"),
    "Cricketset21": t("21th Inning"),
    "Cricketset22": t("22th Inning"),
    "Cricketset23": t("23th Inning"),
    "Cricketset24": t("24th Inning"),
    "Cricketset25": t("25th Inning")
};

/**
 * Replaces game period name like "set0" with a readable text corresponding to sport.
 * @param {String} stateName raw state
 * @param {String} sportAlias sport's alias
 * @returns {String}
 */
export const convertGameStateName = (stateName, sportAlias = "") => (replacements[sportAlias + stateName] || replacements[stateName] || stateName);